import { Contexte } from '@lectra/react-authentication';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';



const initialState: Contexte = {
    accessToken:'',
    actions: {
        logout : (options) => { 

        }
    }
}



const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, userAuth: PayloadAction<Contexte>) => {
            Object.assign(state, userAuth.payload);
        }
    }
})



export const { setCredentials } = authSlice.actions
export const userStateReducer = authSlice.reducer;
